import { render, staticRenderFns } from "./ShowMoreButton.vue?vue&type=template&id=3290f4b4&scoped=true"
import script from "./ShowMoreButton.vue?vue&type=script&lang=js"
export * from "./ShowMoreButton.vue?vue&type=script&lang=js"
import style0 from "./ShowMoreButton.vue?vue&type=style&index=0&id=3290f4b4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3290f4b4",
  null
  
)

export default component.exports